<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="allSupplyOrders"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>SUPPLY ORDERS</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn color="success" outlined @click="openNewDialog()">
            Create new <v-icon right>mdi-plus-box</v-icon>
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:[`item.ActualArrivalDate`]="{ item }">
        <span>{{ formatDate(item.ActualArrivalDate) }}</span>
      </template>
      <template v-slot:[`item.ExpectedDate`]="{ item }">
        <div v-if="formatBasedonToday(item) == 1">
          <span style="color: green">
            <!-- is today -->
            {{ formatDate(item.ExpectedAt) }}
          </span>
        </div>
        <div v-else-if="formatBasedonToday(item) == 0">
          <!-- is late -->
          <span style="color: red">
            {{ formatDate(item.ExpectedAt) }}
          </span>
        </div>
        <div v-else>
          <span>
            {{ formatDate(item.ExpectedAt) }}
            <!-- other -->
          </span>
        </div>
      </template>
      <template v-slot:[`item.notes`]="{ item }">
        <span style="white-space: pre">{{ item.Notes }}</span>
      </template>
      <template v-slot:[`item.ExpectedContents`]="{ item }">
        <span>
          Pallets: {{ item.Pallets }} <br />
          Boxes: {{ item.Boxes }} <br />
          Pcs: {{ item.Pcs }}
        </span>
      </template>
      <template v-slot:[`item.Actions`]="{ item }">
        <v-icon
          v-if="item.SOStatus == 'new'"
          @click="openCollect(item)"
          color="success"
        >
          mdi-check-bold
        </v-icon>
        <v-icon v-else @click="openCollect(item)" color="error">
          mdi-arrow-left
        </v-icon>
        <br />

        <v-icon @click="openEdit(item)" color="warning"> mdi-pencil </v-icon>
        <br />

        <!-- <v-icon @click="openDelete(item)" >
                  mdi-delete
            </v-icon> -->
      </template>
      <template v-slot:[`item.files`]="{ item }">
        <div v-for="(file, id) of item.Files" :key="id">
          <v-icon @click="getFile(file)"> mdi-file-multiple-outline </v-icon>
          {{ file.originalname }}
          <v-btn
            text
            max-width="30"
            max-height="30"
            fab
            @click="deleteFile(item, file)"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <br />
        </div>
      </template>
      <template v-slot:[`item.Status`]="{ item }">
        <div v-if="item.SOStatus == 'new'">
          <span style="color: orange"> New </span>
        </div>
        <div v-else>
          <span style="color: green"> Collected </span>
        </div>
      </template>
    </v-data-table>

    <!--  ADD NEW SO DIALOG  -->
    <v-dialog v-model="addDialog" max-width="1000px">
      <v-form>
        <!-- ref="addForm" v-model="valid" lazy-validation-->
        <v-card>
          <v-card-title class="color: footer">
            <span class="headline"> {{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    type="text"
                    v-model="Brand"
                    label="Brand/Supplier"
                    :rules="[rules.required]"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    type="text"
                    v-model="ArrivesFrom"
                    label="Arrives from"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-menu
                    v-model="menuDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    outlined
                    dense
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="ExpectedAt"
                        label="Expected arrival date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="ExpectedAt"
                      @input="menuDate = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    type="text"
                    v-model="CarNumber"
                    label="Vehicle registration number"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-textarea
                    label="Driver's information"
                    v-model="DriverInformation"
                    hint="Driver's contact information"
                    rows="1"
                    auto-grow
                    outlined
                    dense
                  ></v-textarea>
                </v-col>
              </v-row>
              Expected quantities
              <v-divider class="my-2"></v-divider>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    type="number"
                    v-model="Pallets"
                    label="Num. of pallets"
                    outlined
                    dense
                    min="0"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    type="number"
                    v-model="Boxes"
                    label="Num. of boxes"
                    outlined
                    dense
                    min="0"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    type="number"
                    v-model="Pcs"
                    label="Pcs."
                    outlined
                    dense
                    min="0"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-textarea
                    v-model="Notes"
                    outlined
                    dense
                    label="Notes"
                    rows="2"
                    background-color="amber lighten-4"
                    color="orange orange-darken-4"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-file-input
                  v-model="files"
                  placeholder="Files"
                  label="File input"
                  multiple
                  prepend-icon="mdi-paperclip"
                  outlined
                  dense
                >
                  <template v-slot:selection="{ text }">
                    <v-chip small label color="primary">
                      {{ text }}
                    </v-chip>
                  </template>
                </v-file-input>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" outlined @click="addDialog = false">
              Cancel
            </v-btn>
            <v-btn color="success" outlined @click="addSupplyOrder">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <!---------------------------------------------------------------->
    <!--  EDIT SO DIALOG  -->
    <v-dialog v-model="dialogEdit" max-width="1000px">
      <v-form>
        <!-- ref="addForm" v-model="valid" lazy-validation-->
        <v-card>
          <v-card-title>
            <span class="headline"> {{ item.SOTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    type="text"
                    v-model="item.Brand"
                    label="Brand/Supplier"
                    :rules="[rules.required]"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    type="text"
                    v-model="item.ArrivesFrom"
                    label="Arrives from"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-menu
                    v-model="menuDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="ExpectedAt"
                        label="Expected arrival date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="ExpectedAt"
                      @input="menuDate = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    type="text"
                    v-model="item.CarNumber"
                    label="Vehicle registration number"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-textarea
                    label="Driver's information"
                    v-model="item.DriverInformation"
                    hint="Driver's contact information"
                    rows="1"
                    auto-grow
                    outlined
                    dense
                  ></v-textarea>
                </v-col>
              </v-row>
              Expected quantities
              <v-divider class="my-2"></v-divider>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    type="number"
                    v-model="item.Pallets"
                    label="Num. of pallets"
                    outlined
                    dense
                    min="0"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    type="number"
                    v-model="item.Boxes"
                    label="Num. of boxes"
                    outlined
                    dense
                    min="0"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    type="number"
                    v-model="item.Pcs"
                    label="Pcs."
                    outlined
                    dense
                    min="0"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-textarea
                    v-model="item.Notes"
                    outlined
                    dense
                    label="Notes"
                    rows="2"
                    background-color="amber lighten-4"
                    color="orange orange-darken-4"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <span v-for="(file, id) of item.Files" :key="id">
                  <v-icon @click="getFile(file)">
                    mdi-file-multiple-outline
                  </v-icon>
                  {{ file.originalname }}
                  <v-btn
                    text
                    max-width="30"
                    max-height="30"
                    class="mx-4 my-"
                    fab
                    @click="deleteFile(item, file)"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </span>
              </v-row>
              <v-row>
                <v-file-input
                  v-model="files"
                  placeholder="Files"
                  label="File input"
                  multiple
                  prepend-icon="mdi-paperclip"
                  outlined
                  dense
                >
                  <template v-slot:selection="{ text }">
                    <v-chip small label color="primary">
                      {{ text }}
                    </v-chip>
                  </template>
                </v-file-input>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-menu
                    v-model="menuDateActual"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="ActualArrivalDate"
                        label="Actual arrival date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="ActualArrivalDate"
                      @input="menuDateActual = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" outlined @click="dialogEdit = false">
              Cancel
            </v-btn>
            <v-btn color="success" outlined @click="editSupplyOrder(item)">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-----------------STATUS DIALOG--------------------------------------------------->
    <v-dialog persistent v-model="statusDialog" width="unset">
      <status-info
        :responseMessage="responseMessage"
        :filename="filename"
        :pending="pending"
        @close="closeStatusDialog"
        :textColor="textColor"
      ></status-info>
    </v-dialog>
    <!---------------------------------------------------------------------------------->
  </v-container>
</template>
<script>
import StatusInfo from "../organisms/StatusInfo.vue";
// import { io } from "socket.io-client";
import moment from "moment";
moment().format();

export default {
  name: "supply",
  components: {
    StatusInfo,
  },
  data: () => ({
    errors: [],
    search: "",
    valid: true,
    menuDate: false,
    menuDateActual: false,
    rules: {
      required: (value) => !!value || "Field is required.",
    },
    allSupplyOrders: [],
    headers: [
      { text: "Order number", value: "SOTitle" },
      { text: "Status", value: "Status" },
      { text: "Brand/Supplier", value: "Brand" },
      { text: "Arrives from", value: "ArrivesFrom" },
      {
        text: "Expected arrival date",
        value: "ExpectedDate",
      },
      {
        text: "Actual arrival date",
        value: "ActualArrivalDate",
      },
      { text: "Expected contents", value: "ExpectedContents" },
      { text: "Driver's information", value: "DriverInformation" },
      { text: "Notes", value: "notes" },
      { text: "Files", value: "files" },
      { text: "Actions", value: "Actions" },
    ],
    Brand: "",
    ArrivesFrom: "",
    ExpectedAt: new Date().toISOString().substr(0, 10),
    ActualArrivalDate: new Date().toISOString().substr(0, 10),
    CarNumber: "",
    DriverInformation: "",
    Pallets: 0,
    Boxes: 0,
    Pcs: 0,
    Notes: "",
    files: [],
    addDialog: false,
    dialogDelete: false,
    dialogEdit: false,
    item: {},
    itemExpectedDate: "",
    itemDrand: "",
    itemArrivesFrom: "",
    itemVehicleNum: "",
    itemDriverInfo: "",
    itemPallets: "",
    itemBoxes: "",
    itemPcs: "",
    itemNotes: "",
    itemFiles: [],
    responseMessage: "",
    statusDialog: false,
    filename: "",
    pending: false,
    textColor: "",
  }),
  methods: {
    deleteFile(item, file) {
      var data = { fileName: file.fileName, SOTitle: item.SOTitle };
      this.$store
        .dispatch("deleteSOFile", data)
        .then(() => {
          var indx = item.Files.indexOf(file);
          item.Files.splice(indx, 1);
          // eslint-disable-next-line no-unused-vars
        })
        .catch((error) => {
          console.log("error", error);
          this.errors.push(error);
        });
    },
    editSupplyOrder(item) {
      this.pending = true;
      this.statusDialog = true;
      this.dialogEdit = false;

      item["files"] = this.files;
      var data = [];
      let bodyFormData = new FormData();
      bodyFormData.append("Brand", item.Brand);
      bodyFormData.append("ArrivesFrom", item.ArrivesFrom);
      bodyFormData.append("ExpectedAt", this.ExpectedAt);
      bodyFormData.append("CarNumber", item.CarNumber);
      bodyFormData.append("DriverInformation", item.DriverInformation);
      bodyFormData.append("Pallets", item.Pallets);
      bodyFormData.append("Boxes", item.Boxes);
      bodyFormData.append("Pcs", item.Pcs);
      bodyFormData.append("Notes", item.Notes);
      bodyFormData.append("ActualArrivalDate", this.ActualArrivalDate);
      for (var tempfile of item.files) {
        bodyFormData.append("files", tempfile);
      }
      for (var tempFile of item.Files) {
        bodyFormData.append("Files", JSON.stringify(tempFile));
      }

      data.push(item.SOTitle);
      data.push(bodyFormData);
      this.$store
        .dispatch("editSupplyOrder", data)
        .then(() => {
          this.pending = false;
          this.responseMessage = `Success! Supply ${item.SOTitle} was updated.`;
          this.filename = "high_five.png";
        })
        .catch((error) => {
          console.log("error", error);
          this.errors.push(error);
        });
    },
    changeState(item) {
      //changeSOState
      this.$store
        .dispatch("changeSOState", item.SOTitle)
        .then(() => {})
        .catch((error) => {
          console.log("error", error);
          this.errors.push(error);
          this.allSupplyOrders = [];
        });
    },
    getFile(file) {
      // downloadSupplyFile
      this.$store
        .dispatch("downloadSupplyFile", file)
        .then((response) => {
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: file.mimetype })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", file.originalname);
          document.body.appendChild(link);
          link.click();
          // eslint-disable-next-line no-unused-vars
        })
        .catch((error) => {
          console.log("error", error);
          this.errors.push(error);
          this.allSupplyOrders = [];
        });
    },
    formatDate(date) {
      if (date) {
        return date.split("T")[0];
      } else {
        return null;
      }
    },
    formatBasedonToday(item) {
      var now = new Date().toISOString().split("T")[0];
      var today = new Date(now).getTime();
      var expected = new Date(item.ExpectedAt).getTime();

      if (today == expected) {
        return -1;
      } else if (today > expected) {
        return 0;
      } else {
        return 1;
      }
    },
    async getAllSupplyOrders() {
      try {
        const response = await this.$store.dispatch("getAllSupplyOrders");
        let sorted = response.data;
        sorted.sort(function (a, b) {
          return new Date(b.ExpectedAt) - new Date(a.ExpectedAt);
        });
        this.allSupplyOrders = sorted;
      } catch (error) {
        console.log("error", error);
        this.errors.push(error);
        this.allSupplyOrders = [];
      }
    },
    openNewDialog() {
      this.addDialog = true;
      this.ExpectedAt = new Date().toISOString().substr(0, 10);
    },
    openEdit(item) {
      // this.formattedExpectedDate = this.formatDate(item);
      this.ExpectedAt = item.ExpectedAt.split("T")[0];
      if (item.ActualArrivalDate) {
        this.ActualArrivalDate = this.formatDate(item.ActualArrivalDate);
      } else {
        this.ActualArrivalDate = new Date().toISOString().substr(0, 10);
      }

      this.item = item;
      this.dialogEdit = true;
    },
    openCollect(item) {
      this.$store
        .dispatch("changeSOState", {
          SOTitle: item.SOTitle,
        })
        .then((response) => {
          var resp = response.data;
          item.SOStatus = resp.SOStatus;
          // eslint-disable-next-line no-unused-vars
        })
        .catch((error) => {
          console.log("error", error);
          this.errors.push(error);
        });
    },
    addSupplyOrder() {
      this.pending = true;
      this.statusDialog = true;

      this.addDialog = false;

      let bodyFormData = new FormData();
      bodyFormData.append("Brand", this.Brand);
      bodyFormData.append("ArrivesFrom", this.ArrivesFrom);
      bodyFormData.append("ExpectedAt", Date(this.ExpectedAt));
      bodyFormData.append("CarNumber", this.CarNumber);
      bodyFormData.append("DriverInformation", this.DriverInformation);
      bodyFormData.append("Pallets", this.Pallets);
      bodyFormData.append("Boxes", this.Boxes);
      bodyFormData.append("Pcs", this.Pcs);
      bodyFormData.append("Notes", this.Notes);
      bodyFormData.append("files", this.files);

      //addSupplyOrder
      this.$store
        .dispatch("addSupplyOrder", bodyFormData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          this.pending = false;
          this.responseMessage = `Success! Supply added.`;
          this.filename = "high_five.png";
          // eslint-disable-next-line no-unused-vars
        })
        .catch((error) => {
          console.log("error", error);
          this.errors.push(error);
        });
    },
    async closeStatusDialog() {
      // this.$router.go();
      await this.getAllSupplyOrders();
      this.statusDialog = false;
    },
    formatActualArrivalDate(date) {
      if (date) {
        let seconds = date._seconds;

        let result = moment(seconds * 1000).format("YYYY-MM-DD");

        return result;
      }
    },
  },
  computed: {
    formTitle() {
      return this.addDialog == true ? "New Supply Order" : "Edit Supply Order";
    },
  },
  mounted() {
    // get all supply orders
    this.getAllSupplyOrders();
    // let token = localStorage.getItem("token");
    // this.$store.dispatch("clearNotifications", token);
  },
};
</script>
